module.exports = __webpack_public_path__ + "img/frame (112).5d778025.jpg";